/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_Revoke_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to revoke relay." |
*
* @param {Agents_Revoke_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agents_revoke_error = /** @type {((inputs?: Agents_Revoke_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Revoke_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Relay konnte nicht widerrufen werden.")
	return /** @type {LocalizedString} */ ("Failed to revoke relay.")
});